import * as React from 'react';
import  {
  withStyles,
  WithStyles,
  StyleRules,
ClassNameMap
} from '@mui/styles';
import {Theme} from '@mui/styles';
import {PredefinedField} from '~common/lib/types';
import RendererRegistry from '~common/lib/renderers'


const styles = (theme: Theme): StyleRules => ({
  suggestion: {
    color: 'blue'
  },
  formField: {
    width: '100%'
  }
});

// BEFORE YOU ADD PROPS HERE:  Please consider that this is a HELPER to use when building forms where the Primary considerations are the contents of the form definition
// Please consider whther adding a property here is really necessary, or wether it belongs as part of the form definition, itself, or whether you should really be using
// one of the underlying controls directly.
interface Props {
  data: any | undefined;
  fieldDefinition?: PredefinedField;
}

type State = {
  value?: any;
};

class RemitVendorSuggestionRenderer extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
  }

  static register = () => {
    if (!RendererRegistry.find('RemitVendorSuggestionRenderer')) {
      RendererRegistry.register(
        'RemitVendorSuggestionRenderer',
        RemitVendorSuggestionRenderer
      );
    }
  }

  render() {

    const {data} = this.props;

    //const { classes }: { classes: ClassNameMap; } = this.props;
    

    return (
      <div style={{minWidth:300, fontSize: "0.8rem", display: "flex", flexDirection:"column"}}>
        <div style={{fontWeight: 500, marginBottom: 3 }}>{data.label}</div>
        <div style={{display: "flex"}}>
          <div style={{width: "70%"}}>
            <div className="MuiFormLabel-root" style={{fontSize: "0.5rem", color:"#333"}}>Address</div>
            <div style={{}}>{data.value.address1}</div>
            <div style={{}}>{data.value.address2}</div>
            <div style={{}}>{data.value.city}, {data.value.state} {data.value.postalCode}</div>
          </div>
          <div style={{width: "30%"}}>
            <div style={{fontWeight: 500, fontSize: "0.5rem", color: "#333"}}>1099?</div>
            <div style={{}}>{data.value.vendor1099}</div>
          </div>
        </div>
      </div>
    );

  }
}

export default withStyles(styles)(RemitVendorSuggestionRenderer);

